import React from "react";
import {WrapperLogoStyled} from "./styled.jsx";
import PropTypes from "prop-types";

export const Logo = ({logoPath = null}) => {
  return (
      <WrapperLogoStyled>
        <img
            className="plaidMazoomaLogo"
            src={logoPath}
            alt={logoPath}
        />
      </WrapperLogoStyled>
  );
};


Logo.propTypes = {
  /**
   * What logo to use
   */
  logoPath: PropTypes.string
};

